/* global module, require */
const THREE = require('three'),
	asBuffer = require('../asBuffer'),
	unit = require('../unit');

const d = unit.mm(11),
	kw1 = unit.mm(9),
	kw2 = unit.mm(8);

/* unused params
const wire = unit.mm(4),
	pin = unit.mm(5),
	g = 'm6', // todo
	a = unit.mm(7.5),
	b = unit.mm(12.2),
	l1 = unit.mm(77);
*/

const rh = THREE.Math.degToRad(90);

/* unknown measurements */

const xl = unit.mm(60),
	yl = unit.mm(10),
	zl = unit.mm(6);

const geo = new THREE.Geometry();
const id = new THREE.Matrix4();

const x = new THREE.CylinderGeometry(d / 2, d / 2, xl)
	.rotateX(rh)
	.translate(0, 0, xl / 2);
geo.merge(x, id);

const y = new THREE.CylinderGeometry(kw1 / 2, kw1 / 2, yl)
	.rotateX(rh)
	.translate(0, 0, xl + yl / 2);
geo.merge(y, id);

const z = new THREE.CylinderGeometry(kw2 / 2, kw2 / 2, zl)
	.rotateX(rh)
	.translate(0, 0, xl + yl + zl / 2);
geo.merge(z, id);

module.exports = asBuffer(geo);
